import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { DxauthService } from 'src/app/dxauth.service';
import { environment } from 'src/environments/environment';
import { Auth0Service } from '../../services/auth0.service';
import {
  AccessDenied,
  AuthorizationCode,
  LandingParams,
  VerifyEmail,
} from './landing.interface';

type NewType = Partial<{
  client_id: string;
  state: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  nonce: string;
  code_challenge: string;
  code_challenge_method: 'S256';
}>;

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
})
export class LandingComponent implements OnInit {
  error?: string;
  error_description?: string;

  constructor(
    private activeRoute: ActivatedRoute,
    private service: Auth0Service,
    private route: Router,
    private dxauth: DxauthService
  ) {
    const queryParams = activeRoute.snapshot.queryParams as LandingParams;
    if (this.isVerifyEmail(queryParams)) {
      return;
    }
    if (this.isError(queryParams)) {
      if (queryParams.error_description === 'verify_email') {
        const savedQueryParams = this.savedQuery;
        if (!savedQueryParams) {
          history.back();
        }

        this.route.navigate(['register-send']);
        return;
      }

      this.errorHandling(queryParams);
      return;
    }

    if (this.isAuthorizationCode(queryParams)) {
      this.successHandling(queryParams);
      return;
    }
  }

  private isAuthorizationCode(p: any): p is AuthorizationCode {
    return p.code !== undefined && p.state !== undefined;
  }

  private isError(p: any): p is AccessDenied {
    return p.error !== undefined;
  }

  private isVerifyEmail(p: any): p is VerifyEmail {
    return p.supportSignUp !== undefined;
  }

  private successHandling(queryParams) {
    const code = queryParams.code;
    if (!queryParams.state) {
      this.error = 'invalid_state';
      this.error_description = 'stateが存在しません';
    }
    if (
      sessionStorage.getItem(sessionStorageKey.isAccountIntegrationClientId)
    ) {
      // 仮アプリログイン時はログイン処理を走らせずにアカウント連携ページへ遷移させる
      location.pathname = 'account-integration';
      return;
    }
    const resendInviteEmailTo = sessionStorage.getItem(
      sessionStorageKey.loginAndResendInviteEmail
    );
    if (resendInviteEmailTo) {
      const savedQueryParams: NewType = JSON.parse(
        sessionStorage.getItem(environment.sessionStorageKey)
      );
      // 削除しておく
      sessionStorage.removeItem(sessionStorageKey.loginAndResendInviteEmail);
      // メール送信済みページへ遷移
      this.route.navigate(['register-send']);
      this.dxauth.resendInviteEmail({
        clientId: savedQueryParams.client_id,
        email: resendInviteEmailTo,
      });
      return;
    }
    try {
      const savedQueryParams: NewType = JSON.parse(
        sessionStorage.getItem(environment.sessionStorageKey)
      );

      // 使い終わったら削除
      sessionStorage.removeItem(environment.sessionStorageKey);
      this.service.authorize({
        clientId: savedQueryParams.client_id,
        state: savedQueryParams.state,
        redirectUri: savedQueryParams.redirect_uri,
        responseMode: undefined,
        responseType: savedQueryParams.response_type,
        scope: savedQueryParams.scope,
        nonce: savedQueryParams.nonce,
        code_challenge: savedQueryParams.code_challenge,
        code_challenge_method: savedQueryParams.code_challenge_method,
      });
    } catch (error) {
      console.error(error);
    }
  }

  private errorHandling(queryParams) {
    this.error = queryParams.error;
    this.error_description = queryParams.error_description;
    const savedQueryParams = JSON.parse(
      sessionStorage.getItem(environment.sessionStorageKey)
    );

    if (queryParams.redirect) {
      this.redirectAfterLogout(queryParams);
    } else {
      this.service.logout(
        savedQueryParams.client_id,
        `${location.href}&redirect=true`
      );
    }
  }

  get savedQuery() {
    const savedQueryParams = JSON.parse(
      sessionStorage.getItem(environment.sessionStorageKey)
    );
    return savedQueryParams;
  }
  redirectAfterLogout(queryParams) {
    const savedQueryParams = this.savedQuery;

    const search = Object.keys(savedQueryParams)
      .map((e) => `${e}=${savedQueryParams[e]}`)
      .join('&');

    const messages = {
      invalid_role: 'このアプリケーションにはログインできません',
    };
    this.route.navigate(['/authorize'], {
      queryParams: {
        ...savedQueryParams,
        error:
          messages[queryParams.error_description] ||
          'ログイン時にエラーが発生しました',
      },
    });
  }

  ngOnInit(): void {}
}
